import { render, staticRenderFns } from "./SupplierType.vue?vue&type=template&id=454511c1&scoped=true"
import script from "./SupplierType.vue?vue&type=script&lang=js"
export * from "./SupplierType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454511c1",
  null
  
)

export default component.exports